const deepcopy = require('deepcopy');

export default {
    name: 'Register-step3',
    props: {
        tmnomenics: {
            type: Array,
        },
        callbackInfo: {
            type: Object,
        },
    },
    data() {
        return {
            inputMnomentics: {},
            mnomenics: [],
            randomArr: [],
            mnomenicsStatus: {
                checked: false,
            },
        };
    },
    mounted() {
        this.initArr();
    },
    watch: {
        callbackInfo(n) {
            const self = this;
            const newValue = n;
            if (newValue.code !== 0) {
                self.$Message.error(self.$t(newValue.errmsg));
            }
        },
    },
    methods: {
        initArr() {
            const self = this;
            const data = deepcopy(self.tmnomenics);
            const randomNum = self.randomNum();
            randomNum.forEach((v) => {
                data[v] = '';
            });
            self.randomArr = randomNum;
            const newObj = self.formatInputArr(data);
            self.mnomenics = data;
            self.inputMnomentics = newObj;
        },
        detectType(i) {
            const self = this;
            const arr = self.randomArr;
            return arr.indexOf(i);
        },
        inputOnchange(e) {
            // eslint-disable-next-line no-console
            console.log(e);
        },
        formatInputArr(arr) {
            const newObj = {};
            const baseArr = arr;
            baseArr.forEach((v, i) => {
                newObj[i] = v;
            });
            return baseArr;
        },
        randomNum(len = 13, count = 6) {
            const randomArr = [];
            const baseLen = len;
            const baseCount = count;
            while (randomArr.length < baseCount) {
                const randomNum = Math.floor(Math.random() * baseLen);
                if (randomArr.indexOf(randomNum) < 0) {
                    randomArr.push(randomNum);
                }
            }
            return randomArr;
        },
        backToStep2() {
            const self = this;
            self.$emit('backToStep2', '');
        },
        completeRegister() {
            const self = this;
            const mnomenics = self.mnomenics;
            if (self.mnomenicsStatus.checked) {
                self.$emit('completeRegister', mnomenics);
            } else {
                self.$Message.error(self.$t('account_please_agree_the_anouncement_below'));
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/ruc/registerStep3.js